/*******************************************************************************
GET LIMIT MODE
There can be limited space to display data points on chart so this function adapts how
the chart is displayed based on the number of data points and the available width.
It flips between showing all data points ("all"), showing every other data point ("everyOther"),
or showing only key data points [start, end, min, max] ("key").
*******************************************************************************/

export default function getLimitMode(chartWidthPixels, numDataPoints) {
    if (chartWidthPixels < 350) {
        if (numDataPoints > 10) { return 'key'; }
        return 'all';
    }
    if (chartWidthPixels < 450) {
        if (numDataPoints > 15) { return 'key'; }
        return 'all';
    }
    if (chartWidthPixels < 700) {
        if (numDataPoints > 40) { return 'key'; }
        if (numDataPoints > 20) { return 'everyOther'; }
        return 'all';
    }
    if (chartWidthPixels < 800) {
        if (numDataPoints > 50) { return 'key'; }
        if (numDataPoints > 25) { return 'everyOther'; }
        return 'all';
    }
    if (chartWidthPixels < 950) {
        if (numDataPoints > 60) { return 'key'; }
        if (numDataPoints > 30) { return 'everyOther'; }
        return 'all';
    }
    if (chartWidthPixels < 1050) {
        if (numDataPoints > 70) { return 'key'; }
        if (numDataPoints > 35) { return 'everyOther'; }
        return 'all';
    }
    if (numDataPoints > 80) { return 'key'; }
    if (numDataPoints > 40) { return 'everyOther'; }
    return 'all';
}
